import { usePlayground } from "@/components/Playground2/playground-store";
import suggestion from "../Nodes/InputVariable/suggestion";

const useDetectedInputVariableSuggestions = () => {
  try {
    const playground = usePlayground();

    const getVariables = () => playground.detectedInputVariables;

    return suggestion(getVariables);
  } catch (e) {
    return [];
  }
};

export default useDetectedInputVariableSuggestions;
